module.exports = __webpack_public_path__ + "img/1lf.d364dd8a.png";